export default "__VITE_ASSET__4e3d746b__"